module.exports = __webpack_public_path__ + "img/arrow-bar-right.f7c44040.svg";